import type { BFFArticleBodyElement } from "@src/app/types/bff";

export default function ArticleYoutube({
  element,
}: {
  element: BFFArticleBodyElement["youtube_video"];
}) {
  return (
    <div className="pb-4">
      <iframe
        className="aspect-[3/2] w-full"
        src={element.url}
        title={element.title}
        allowFullScreen
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
      />

      {/* Does not support description for YouTube videos in the current implementation */}
      {/* Uncomment if description support is added in the future */}
      {/* {element.description ? (
        <p className="mt-4 mx-3 text-tertiary text-body-2 text-center">
          {element.description}
        </p>
      ) : null} */}
    </div>
  );
}
